import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { FILTER_DEFAULT_CD_LOGIN, LOGIN_USUARIO_CONTATO, FILTER_DEFAULT_BACEN_MATRICULA, FILTER_DEFAULT_CENTRUS_MATRICULA, FILTER_DEFAULT_CONFIRMA_PLANO_PATROCINADORA_BACEN_PCD, FILTER_DEFAULT_CONFIRMA_PLANO_PATROCINADORA_CENTRUS_PCD, FILTER_DEFAULT_BACEN_MATRICULA_CONFIRMA_LISTA, ITEM_MENU, BACK_END_CONTROLE_ACESSO } from '../../../app.constants';
import { ContatoRecuperarAcesso } from '../dominios/contato-recuperar-acesso';
import { ItemMenu } from '../dominios/item-menu';
import { UtilService } from '../util/util.service';



@Injectable()
export class FilterDefaultService {


  constructor(
    private http: HttpClient
  ) {

  }

  findByCentrusPB(cdCentrus: number) {
    return this.http.get(`${FILTER_DEFAULT_BACEN_MATRICULA}/${cdCentrus}`)
      .toPromise();
  }

  findByCentrusPBConfirmaLista(cdCentrus: number) {
    return this.http.get(`${FILTER_DEFAULT_BACEN_MATRICULA_CONFIRMA_LISTA}/${cdCentrus}`)
      .toPromise();
  }

  findByCentrusPC(cdCentrus: number) {
    return this.http.get(`${FILTER_DEFAULT_CENTRUS_MATRICULA}/${cdCentrus}`)
      .toPromise();
  }

  findByCentrusMatriculas(cdCentrus: number) {
    return this.http.get(`${BACK_END_CONTROLE_ACESSO + 'patrocinadoras-lista'}/${cdCentrus}`)
      .toPromise();
  }

  findBysMatriculasBacen(cdCentrus: number) {
    return this.http.get(`${BACK_END_CONTROLE_ACESSO + 'matriculas-bacen-lista'}/${cdCentrus}`)
      .toPromise();
  }


  getConfirmaPlanoPatrocinadoraBacenPCD(cdCentrus: number): Promise<string> {
    return this.http.get<string>(`${FILTER_DEFAULT_CONFIRMA_PLANO_PATROCINADORA_BACEN_PCD}/${cdCentrus}`)
      .toPromise();
  }

  getConfirmaPlanoPatrocinadoraCentrusPCD(cdCentrus: number): Promise<string> {
    return this.http.get<string>(`${FILTER_DEFAULT_CONFIRMA_PLANO_PATROCINADORA_CENTRUS_PCD}/${cdCentrus}`)
      .toPromise();
  }

  getIPAddress() {
    return this.http.get('http://api.ipify.org/?format=json', UtilService.getOptionsHeaders()).toPromise();
  }


  getItemMenuId(id): Promise<ItemMenu> {
    return this.http.get<ItemMenu>(`${ITEM_MENU}/${id}`).toPromise();
  }

  // getFilterDefaultIditemmenu(iditemmenu: number) {
  //   return this.http.get<OperacaoItemMenuSistema[]>(`${FILTER_DEFAULT_ID_ITEM_MENU}${iditemmenu}`)
  //   .toPromise();
  // }


  // getFilterDefaultGrupoAcessoIdSistema(idSistema: number) {
  //   return this.http.get<GrupoAcesso[]>(`${FILTER_DEFAULT_GRUPO_ACESSO_ID_SISTEMA}${idSistema}`)
  //   .toPromise();
  // }


  // getFilterDefaultItemMenuIdSistema(idSistema: number) {
  //   return this.http.get<ItemMenu[]>(`${FILTER_DEFAULT_ITEM_MENU_ID_SISTEMA}${idSistema}`)
  //   .toPromise();
  // }

  // getFilterDefaultIdItemMenuFuncionalidade(idItemMenu: number) {
  //   return this.http.get<Funcionalidade[]>(`${FILTER_DEFAULT_ID_ITEM_MENU_FUNCIONALIDADE}${idItemMenu}`);
  // }

  // getFilterDefaultNoPessoa(noPessoa: string) {
  //   return this.http.get(`${FILTER_DEFAULT_NO_PESSOA_COM_CD_CENTRUS}${noPessoa}`);
  // }

  // getFilterDefaultDsPerfil(sgPerfil: string) {
  //   return this.http.get<string[]>(`${FILTER_DEFAULT_DS_PERFIL}${sgPerfil}`)
  // }

  // getFilterDefaultDsSistema(dssistema: string) {
  //   return this.http.get<string[]>(`${FILTER_DEFAULT_DS_SISTEMA}${dssistema}`);
  // }

  // getFilterDefaultDsItemMenu(sgitemmenu: string) {
  //   return this.http.get<ItemMenu[]>(`${FILTER_DEFAULT_DS_ITEM_MENU}${sgitemmenu}`);
  // }

  // getFilterDefaultDsOperItemMenuSist(sgOperItemMenuSist: string) {
  //   return this.http.get<OperacaoItemMenuSistema[]>(`${FILTER_DEFAULT_DS_OPER_ITEM_MENU_SIST}${sgOperItemMenuSist}`);
  // }


  getFilterDefaultCdLogin(cdLogin: string) {
    return this.http.get(`${FILTER_DEFAULT_CD_LOGIN}${cdLogin}`)
      .toPromise();
  }

  // update contatos email e telefone
  postUpdateContatos(contatoRecuperarAcesso: ContatoRecuperarAcesso) {
    return this.http.post(`${LOGIN_USUARIO_CONTATO}`, contatoRecuperarAcesso)
      .toPromise();
  }


  getAndressIPMark() {
    // return this.http
    // .get(`api.ipify.org?format=json` + true)
    // .get('http://freegeoip.net/json/?callback')
    // .toPromise();
    // return this.http.get<{ip:string}>('https://jsonip.com')
    // return this.http.get<{ip:string}>('http://ipinfo.io/?format=jsonp&callback=getIP')
    // return this.http.get<{ip:string}>("//api.ipify.org?format=json" + true)
    // .subscribe( data => {  console.log('th data', data)  })
    // return this.http
    //   .get('http://freegeoip.net/json/?callback');

    // const headers: HttpHeaders = new HttpHeaders();
    // headers.append('Content-Type', 'application/json');
    // headers.append('Access-Control-Allow-Origin', '*');
    // headers.append('Access-Control-Allow-Methods', 'GET, PUT, POST, DELETE, HEAD, OPTIONS');
    // headers.append('Access-Control-Allow-Headers', 'authorization');


    // this.http.get<{ ip: string }>('https://jsonip.com/', { headers: new HttpHeaders().set('Authorization', 'authorization')})
    //   .subscribe(data => {
    //     console.log('th data', data)
    //   })
  }

}



// WEBPACK FOOTER //
// /usr/src/app/src/app/area-restrita/shared/services/filter-default.service.ts